import { ErrorHandler, Injectable, Injector, NgZone, Optional } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { AuthService } from './_services/auth.service';
import { NotificationService } from './_services/notification.service';

@Injectable()
export class ErrorsHandler implements ErrorHandler {
  constructor(
    // Because the ErrorHandler is created before the providers, we’ll have to use the Injector to get them.
    private injector: Injector
  ) {}

  // private isResourceUrl(url: string): boolean {
  //     const found = this.moduleConfig.resourceServer.allowedUrls.find(u => url.startsWith(u));
  //     return !!found;
  // }

  handleError(error: Error | HttpErrorResponse) {
    const notificationService = this.injector.get(NotificationService);
    const _authService = this.injector.get(AuthService);
    const router = this.injector.get(Router);
    const ngZone = this.injector.get(NgZone);

    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened

      let url = 'unknown';
      if (error.url) {
        url = error.url.toLowerCase();
      }

      // if (this.isResourceUrl(url) || url === 'unknown') { return null };

      if (!navigator.onLine) {
        // Handle offline error
        return notificationService.notify('danger', '', 'No Internet Connection', 'top', 'right');
      } else {
        // Handle Http Error (error.status === 403, 404...)
        let status = error.status;
        let message = error.message;
        if (error.error) {
          if (error.error.status) {
            status = error.error.status;
          }
          if (error.error.title) {
            message = error.error.title;
          } else if (error.error.message) {
            message = error.error.message;
          } else if (error.error.error) {
            message = error.error.error;
          }

          if (error.error.path === '/api/ext-image/delete' && error.error.detail.includes('ConstraintViolationException')) {
            message = 'Image cannot be deleted as it is currently in use';
          }
        }

        if (error.error.title === 'Login Credentials Invalid' || error.error.error === 'invalid_token') {
          ngZone.run(() => {
            _authService.logout();
          });
        }

        return notificationService.notify('danger', `Error ${status}`, `${message}`, 'top', 'right');
      }
    } else {
      console.log('client error');
      // Handle Client Error (Angular Error, ReferenceError...)
      ngZone.run(() => {
        router.navigate(['/error'], { queryParams: { error: error } });
      });
    }
    // Log the error anyway
    console.error('It happens: ', error);
  }
}



// WEBPACK FOOTER //
// ./src/app/errors.handler.ts